import React from 'react';
import Select from 'react-select';
import { findIndex } from 'underscore';
import clone from 'clone';

const $ = jQuery;

class SortingPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allmetakeys: this.props.sortingData ? this.props.sortingData : [],
    };
  }

  componentDidMount() {
    jQuery('#sortmeta').sortable({
      handle: '.sort-shortable',
      stop: this.handleSort.bind(this),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sortingData !== null) {
      this.setState({
        allmetakeys: nextProps.sortingData,
      });
    } else {
      this.setState({ allmetakeys: [] });
    }
  }

  handleSort(event) {
    const oldmeta = clone(this.props.sortingData);
    const allmetakeys = [];


    $(event.target).children('.sortingmeta').each((index, item) => {
      const value = $(item).data('value');
      const findKey = findIndex(oldmeta, { value });
      if (findKey !== -1) {
        allmetakeys.push(oldmeta[findKey]);
      }
    });
    this.props.onSortingSubmit(allmetakeys);
  }
  handleChange(data) {
    const allmetakeys = clone(this.state.allmetakeys);
    const self = this;
    const tempmetakeys = [];
    if (data !== null) {
      data.forEach((meta) => {
        const index = findIndex(allmetakeys, { value: meta.value });
        if (index !== -1) {
          tempmetakeys.push({
            value: meta.value,
            label: meta.value,
            title: allmetakeys[index].title,
          });
        } else {
          tempmetakeys.push({
            value: meta.value,
            label: meta.value,
            title: meta.value,
          });
        }
      });
      self.props.onSortingSubmit(tempmetakeys);
      self.setState({ allmetakeys: tempmetakeys });
    } else {
      self.setState({ allmetakeys: [] });
      self.props.onSortingSubmit([]);
    }
  }
  handleRemoveMeta(meta, event) {
    event.preventDefault();
    const allmetakeys = this.state.allmetakeys;
    const findKey = findIndex(allmetakeys, { value: meta.value });
    allmetakeys.splice(findKey, 1);
    this.props.onSortingSubmit(allmetakeys);
    this.setState({ allmetakeys });
  }
  handleChangeMeta(meta, event) {
    meta.title = event.target.value;
    const allmetakeys = this.state.allmetakeys;
    const Index = findIndex(allmetakeys, { value: meta.value });
    allmetakeys[Index] = meta;
    this.props.onSortingSubmit(allmetakeys);
  }

  render() {
    const sortingData = this.state.allmetakeys;
    this.metakeys = [{
      value: 'post_date',
      label: 'post_date',
    }, {
      value: 'comment_count',
      label: 'comment_count',
    }, {
      value: 'post_title',
      label: 'post_title',
    }];
    if (this.props.helperData !== undefined) {
      this.props.helperData.metakeys.forEach((metakey) => {
        this.metakeys.push({
          'value': metakey,
          'label': metakey,
        });
      });
    }

    const sortingValues = [];
    sortingData.forEach((meta) => {
      sortingValues.push(meta.value);
    });
    const sortingValue = sortingValues.join(',');

    const showAllMetakey = (meta, index) => {
      return (
            <div className="sortingmeta" key={'sorting-' + index} data-value={meta.value}>
              <i className="fa fa-ellipsis-h sort-shortable" aria-hidden="true"></i>
              <input type="text" className="reactive-input" defaultValue={meta.title} onChange={this.handleChangeMeta.bind(this, meta)} placeholder={API.LANG.PLACE_TITLE} />
              <a className="metaremove" href="#" onClick={this.handleRemoveMeta.bind(this, meta)}><i className="ion-android-close"></i></a>
            </div>
        );
    };


    return (<div role="tabpanel" className="tab-pane" id="sorting">
      <div className="flex-row">
        <div className="flex-md-6 flex-xs-12">
          <p className="caption">{API.LANG.PLEASE_SELECT_SORTING_ATTRIBUTES}</p>
          <Select onChange={this.handleChange.bind(this)} options={this.metakeys} multi value={sortingValue} />
            <div id="sortmeta">{sortingData.length ? sortingData.map(showAllMetakey) : null }</div>
        </div>
      </div>
    </div>);
  }
}

export default SortingPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/sortingPanel.js